/**
 * Sino de notificações (AB#84509). Hoje cobre um aviso só — convite para uma
 * organização adicional. O épico de notificações (#84880) amplia daqui.
 */
const notifications = {
  title: "Notificações",
  empty: "Nenhuma notificação por enquanto",
  invite: {
    title: "Convite para {{organization}}",
    description:
      "Ao aceitar, esta organização fica disponível para você — seus acessos atuais continuam como estão.",
    accept: "Aceitar convite",
    acceptFailed: "Não foi possível aceitar o convite",
    syncFailed: "Organização adicionada",
    syncFailedDescription: "Recarregue a página para ver seus acessos completos nela.",
  },
} as const;

export default notifications;
